export default class PredictorExplainer {
  constructor(
    public level: "model" | "score",
    public explainerType: "score_distribution_plot" | "explainer_bar_chart",
    public svg: string,
    public title: string
  ) {}
}
